import { render } from "./GoldFeatures.vue?vue&type=template&id=3dff4bda"
import script from "./GoldFeatures.vue?vue&type=script&lang=js"
export * from "./GoldFeatures.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/shop/windowOverlay/GoldFeatures.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3dff4bda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3dff4bda', __exports__)) {
    api.reload('3dff4bda', __exports__)
  }
  
  module.hot.accept("./GoldFeatures.vue?vue&type=template&id=3dff4bda", () => {
    api.rerender('3dff4bda', render)
  })

}


export default __exports__